import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import{ GET_VFOVISIT_FORM_DETAIL,
        GET_SINGLE_VFO_VISIT }from "../../../Types"
import { showLoading, hideLoading } from "react-redux-loading-bar";

export const getVFODailyVistSummaries = (postedData) => async (dispatch) => {
    dispatch(showLoading());
await axios
    .post(`api/VizShopCheckIn/GetVFOVisitListFormDetails`, postedData)
    .then(({ data }) => {
           dispatch({
                type: GET_VFOVISIT_FORM_DETAIL,
                payload: data.response,
              });
        dispatch(hideLoading());
    }).catch(function (error) {
        dispatch(hideLoading());
         if (error.response) {
                if (error.response.status === 401) {
                  logout();
                  history.push("/login");
                  history.go("/login");
                } else if (
                  error.response.status === 400 &&
                  error.response.data.errors
                ) {
                  let errorMessage = "";
                  var errors = error.response.data.errors;
                  var keys = Object.keys(errors);
                  for (let j = 0; j < keys.length; j++) {
                    errorMessage += errors[keys[j]] + " , \n";
                  }
                  toast.error(errorMessage);
                } else if (error.response.data)
                  toast.error(
                    error.response.data.Message
                      ? error.response.data.Message
                      : error.response.data.message
                  );
                else {
                  toast.error("Error while processing the request");
                }
              } else toast.error("Error while processing the request");
    });   
}

export const getSingleVFOVisit = (id) => async (dispatch) => {
    dispatch(showLoading());
await axios
    .get(`api/VizShopCheckIn/GetSingleVFOVisit/`+id)
    .then(({ data }) => {
          dispatch({
                type: GET_SINGLE_VFO_VISIT,
                payload: data.response,
              });
        dispatch(hideLoading());
    }).catch(function (error) {
        dispatch(hideLoading());
        if (error.response) {
                if (error.response.status === 401) {
                  logout();
                  history.push("/login");
                  history.go("/login");
                } else if (
                  error.response.status === 400 &&
                  error.response.data.errors
                ) {
                  let errorMessage = "";
                  var errors = error.response.data.errors;
                  var keys = Object.keys(errors);
                  for (let j = 0; j < keys.length; j++) {
                    errorMessage += errors[keys[j]] + " , \n";
                  }
                  toast.error(errorMessage);
                } else if (error.response.data)
                  toast.error(
                    error.response.data.Message
                      ? error.response.data.Message
                      : error.response.data.message
                  );
                else {
                  toast.error("Error while processing the request");
                }
              } else toast.error("Error while processing the request");
    });  
}